import React from "react";

const ServSpaceLogo = ({ width = 120, height = 60 }) => (
  <svg
    width={width}
    height={height}
    viewBox="20 0 460 120"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="100%" height="100%" fill="black" />

    <g
      transform="translate(60 60)"
      fill="none"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="
          M 0 -20
          A 26 14 0 1 1 0 20
          A 18 10 0 1 0 0 -20
        "
        strokeWidth="3.2"
      />

      <path
        d="
          M 0 -12
          A 16 8 0 1 1 0 12
          A 10 5 0 1 0 0 -12
        "
        strokeWidth="2.2"
        opacity="0.9"
      />

      <circle cx="0" cy="0" r="4" fill="white" />
    </g>

    <text
      x="115"
      y="74"
      fill="white"
      fontSize="35"
      fontWeight="600"
      letterSpacing="0.4"
      fontFamily="
        Canva Sans,
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        Arial,
        sans-serif
      "
    >
      ServSpace AI 
    </text>
  </svg>
);

export default ServSpaceLogo;